module.exports = __webpack_public_path__ + "static/img/app-slide-show5.e3b4eb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-orlkis-wgm/images/app-slide-show5.png
// module id = elHN
// module chunks = 44